import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>Whilst there is no ‘right’ or ‘wrong’ with either belief,
                                                research reveals that having an internal locus
                                                of control makes a person feel more in control of outcomes.
                                                Without this you are likely to be less
                                                motivated to take control at work.</p>
                                            <div className="border_subtitle">Identify your locus of control
                                            </div>
                                            <p>Here are two situations to help you think about your potential
                                                reaction to certain situations and
                                                whether they are typical of someone with an internal or external
                                                locus of control (LOC). For each,
                                                consider which reaction you think is most like your own and look
                                                at the positive and negative
                                                factors associated with it.</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top"
                                                        className="green_curve green_curve1">Scenario 1
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen"><p
                                                        style={{paddingBottom:'5px !important'}}><span
                                                        className="subtiltereg">Scenario:</span> Imagine you
                                                        have applied for a job that you really want. You are
                                                        very excited about the
                                                        type of work and think the company will be great to work
                                                        for. You’re asked to attend an interview,
                                                        but it doesn’t go very well and you’re not successful in
                                                        getting the job.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen"><p><span className="subtiltereg">Possible reaction (internal LOC):</span> You’re
                                                        really disappointed that you did not get the job and
                                                        decide
                                                        that, next time an opportunity arises, you must work
                                                        really hard to be the best candidate.</p>
                                                        <p><span className="subtiltereg">Positives:</span> You
                                                            are going to take control and give yourself a better
                                                            chance of getting the job you
                                                            want next time.</p>
                                                        <p style={{paddingBottom:'5px !important'}}><span
                                                            className="subtiltereg">Negatives:</span> You may
                                                            feel very disappointed and negative about your
                                                            abilities. You may need to
                                                            control your emotional response.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen"><p><span className="subtiltereg">Possible reaction (external LOC): </span> You
                                                        quickly get over the disappointment as you decide that
                                                        it
                                                        obviously wasn’t meant to be.</p>
                                                        <p><span className="subtiltereg">Positives:</span> You
                                                            can quickly overcome the setback.</p>
                                                        <p style={{paddingBottom:'5px !important'}}><span
                                                            className="subtiltereg">Negatives:</span> You may
                                                            not be giving yourself a good chance of getting the
                                                            job you want in future
                                                            because you fail to recognise your weaknesses.</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top"
                                                        className="green_curve green_curve1">Scenario 2
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen"><p
                                                        style={{paddingBottom:'5px !important'}}><span
                                                        className="subtiltereg">Scenario:</span> You have moved
                                                        to a new organisation, and due to being a new arrival,
                                                        your internal
                                                        network is not excellent, and you feel you are missing
                                                        out on support and exciting projects.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen"><p><span className="subtiltereg">Possible reaction (internal LOC):</span> You
                                                        have decided to organise an informal meeting with
                                                        influential people in your area in order to become
                                                        acquainted.</p>
                                                        <p><span className="subtiltereg">Positives:</span> You
                                                            will now be on approachable terms with individuals
                                                            who can provide you with
                                                            resources and allow you to influence decisions
                                                            through them.</p>
                                                        <p style={{paddingBottom:'5px !important'}}><span
                                                            className="subtiltereg">Negatives:</span> Some
                                                            people may feel that you are trying to increase your
                                                            influence without
                                                            it having occurred naturally over time, which may
                                                            give the wrong impression.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen"><p><span className="subtiltereg">Possible reaction (external LOC): </span> You
                                                        don’t take specific action and wait to bump into people
                                                        by
                                                        chance. You think that meeting the right people is down
                                                        to fate.</p>
                                                        <p><span className="subtiltereg">Positives:</span> You
                                                            can allow yourself to influence people based on your
                                                            merits, and allow yourself to
                                                            be noticed due to your positive traits.</p>
                                                        <p style={{paddingBottom:'5px !important'}}><span
                                                            className="subtiltereg">Negatives:</span> You may
                                                            continue to miss out on key events while you wait to
                                                            become a more integral
                                                            part of a work network.</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}